import React from 'react';
import NfProductSearchSelect from '../NonFuelProduct/NfProductSearchSelect.component';
import '../NonFuelProduct/NonFuelProductModal.css';

export const mapPurchaseProductOptions = (productData, chek_rk, currentProductId) => {
  const blocked = new Set(
    (chek_rk || [])
      .filter((id) => id != null && String(id) !== String(currentProductId))
      .map(String)
  );

  return (productData || [])
    .filter(([id]) => !blocked.has(String(id)))
    .map(([id, name]) => ({ value: id, label: name }));
};

const NfPurchaseProductSelect = ({
  inputId,
  hiddenId,
  productData,
  chek_rk,
  value,
  onProductChange,
  hasError = false,
  hiddenClassName = 'rackids product',
}) => {
  const options = mapPurchaseProductOptions(productData, chek_rk, value);

  const handleChange = (productId) => {
    const hidden = document.getElementById(hiddenId);
    if (hidden) {
      hidden.value = productId || '';
    }
    onProductChange(productId);
  };

  return (
    <>
      <NfProductSearchSelect
        inputId={inputId}
        options={options}
        value={value}
        onChange={handleChange}
        hasError={hasError}
        placeholder="Type to search product..."
      />
      <input
        type="hidden"
        id={hiddenId}
        className={hiddenClassName}
        name="product_id"
        value={value || ''}
        readOnly
      />
    </>
  );
};

export default NfPurchaseProductSelect;
